import { render, staticRenderFns } from "./JgpSlider.vue?vue&type=template&id=fdde1948&"
import script from "./JgpSlider.vue?vue&type=script&lang=js&"
export * from "./JgpSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports